import { GenericAbortSignal } from 'axios';

import http from 'services/http';

export type PermissionDefinition = {
  name: string;
  label: string;
  category: string;
  description?: string;
};

export const adminPermissionsQueryKeys = {
  index: () => ['adminPermissions'] as const,
};

export async function adminIndexPermissions(signal?: GenericAbortSignal) {
  return http.get<PermissionDefinition[]>('admin/permissions', { signal }).then((res) => res.data);
}
